import React, { useEffect, useState } from 'react';
import { Loader2, Users } from 'lucide-react';

import { Button } from '../../ui-v2';
import { Table, EmptyState } from '../../ui-v2.5';
import { getLotes } from '../api';
import { textoCriterio } from './PanelLotes';

/**
 * UsuariosEnLotes — las personas de una campaña en curso, en SOLO LECTURA (DS v2).
 *
 * Con la campaña Activa o Pausada hay una sola puerta para cambiar personas: el panel de lotes del
 * resumen (añadir, quitar, mover; con avisos e historial). Aquí se ve cuántas hay en cada lote y se
 * lleva al panel. El PUT de campaña rechaza (422) una lista distinta.
 */
export default function UsuariosEnLotes({ campanaId, onIrAlPanel }) {
  const [lotes, setLotes] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    let vivo = true;
    getLotes(campanaId)
      .then((l) => { if (vivo) setLotes(l); })
      .catch((e) => { if (vivo) setError(e?.response?.data?.error || 'No se pudieron cargar los lotes.'); });
    return () => { vivo = false; };
  }, [campanaId]);

  // Rediseño (Fase 2): con las cifras de cada lote, las mismas que trae getLotes para el resumen.
  const num = (v) => <span className="tabular-nums">{v ?? 0}</span>;
  const columnas = [
    { key: 'numero', header: 'Nº', width: '56px', render: (l) => <span className="tabular-nums">{l.numero}</span> },
    { key: 'nombre', header: 'Lote', render: (l) => <span className="font-medium text-v25-ink-900">{l.nombre}</span> },
    { key: 'criterio', header: 'Criterio', render: (l) => <span className="text-v25-ink-500">{textoCriterio(l.criterio)}</span> },
    { key: 'total', header: 'Personas', width: '96px', render: (l) => num(l.total) },
    { key: 'realizados', header: 'Realizados', width: '96px', render: (l) => num(l.realizados) },
    { key: 'sin_cita', header: 'Sin cita', width: '96px', render: (l) => num(l.sin_cita) },
    { key: 'con_cita', header: 'Con cita', width: '96px', render: (l) => num(l.con_cita) },
    { key: 'cancelados', header: 'Cancelados', width: '96px', render: (l) => num(l.cancelados) },
  ];

  return (
    <div className="space-y-3">
      <div className="flex items-center justify-between gap-3 flex-wrap">
        <p className="text-sm text-slate-500">
          Con la campaña en curso, las personas se gestionan en sus lotes: añadir, quitar o mover de lote,
          con sus avisos.
        </p>
        <Button size="sm" onClick={onIrAlPanel}>
          <Users className="w-3.5 h-3.5" /> Gestionar personas en los lotes
        </Button>
      </div>
      {error ? (
        <div className="text-sm text-red-700 bg-red-50 border border-red-100 rounded-md p-3">{error}</div>
      ) : lotes === null ? (
        <div className="text-sm text-v25-ink-500"><Loader2 className="w-4 h-4 inline-block animate-spin mr-2" />Cargando…</div>
      ) : (
        <Table columns={columnas} rows={lotes} emptyState={<EmptyState variant="minimal" title="Esta campaña aún no tiene lotes." />} />
      )}
    </div>
  );
}
